export default __webpack_public_path__ + "img/249f9ed633b85dfc85d91744b8905d37.mp4";